import { useState } from "react";
import { Button, Cluster, Input, Modal, Stack } from "@salesapp/ui";

/** Asks for the payment reference and date instead of stamping every payment "MANUAL". */
export function MarkPaidDialog({
  invoiceNumber,
  today,
  onClose,
  onConfirm,
}: {
  invoiceNumber?: string | null;
  today: string;
  onClose: () => void;
  onConfirm: (body: { payment_reference: string; payment_date: string }) => Promise<void>;
}) {
  const [reference, setReference] = useState("");
  const [date, setDate] = useState(today);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const trimmed = reference.trim();

  async function submit() {
    if (!trimmed || !date) return;
    setBusy(true);
    setError(null);
    try {
      await onConfirm({ payment_reference: trimmed, payment_date: date });
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : "The payment could not be recorded.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal
      isOpen
      onClose={onClose}
      title={invoiceNumber ? `Mark ${invoiceNumber} paid` : "Mark invoice paid"}
      footer={
        <Cluster gap={2}>
          <Button variant="ghost" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button onClick={() => submit()} disabled={busy || !trimmed || !date}>
            {busy ? "Saving…" : "Mark paid"}
          </Button>
        </Cluster>
      }
    >
      <Stack gap={3}>
        {error && <p className="crm-error">{error}</p>}
        <Input
          label="Payment reference"
          value={reference}
          maxLength={80}
          placeholder="Bank reference, cheque number or transaction id"
          onChange={(event) => setReference(event.target.value)}
          autoFocus
        />
        <Input label="Payment date" type="date" value={date} onChange={(event) => setDate(event.target.value)} />
      </Stack>
    </Modal>
  );
}
